import { gql } from 'graphql-tag';

/**
 * GraphQL query to get a single user by ID
 */
export const GET_USER = gql`
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      email
      phone
      sexPreference
      colorPreference
      type
      ranking
      startedRanking
      comment
      createdAt
      updatedAt
    }
  }
`;

/**
 * GraphQL query to get multiple users with optional filtering
 */
export const GET_USERS = gql`
  query GetUsers($filter: UserFilter) {
    getUsers(filter: $filter) {
      id
      firstName
      lastName
      email
      phone
      sexPreference
      colorPreference
      type
      ranking
      startedRanking
      comment
      createdAt
      updatedAt
    }
  }
`;

/**
 * GraphQL mutation to create a new user
 */
export const ADD_USER = gql`
  mutation AddUser($input: UserInput!) {
    addUser(input: $input) {
      id
      firstName
      lastName
      email
      phone
      sexPreference
      colorPreference
      type
      ranking
      startedRanking
      comment
      createdAt
      updatedAt
    }
  }
`;

/**
 * GraphQL mutation to update an existing user
 */
export const EDIT_USER = gql`
  mutation EditUser($id: ID!, $input: EditUserInput!) {
    editUser(id: $id, input: $input) {
      id
      firstName
      lastName
      email
      phone
      sexPreference
      colorPreference
      type
      ranking
      startedRanking
      comment
      createdAt
      updatedAt
    }
  }
`;

/**
 * GraphQL mutation to delete a user
 */
export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`;
